module.exports = __webpack_public_path__ + "static/WOW_Logo_only-d47381cda3de1ad4d4a2276d35d79aed.png";